import { Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

// TODO: remove and use from shared  example: {{varible | sanitize : SecurityContext.HTML}}
@Pipe({
    name: 'noSanitize',
    standalone: false,
})
export class NoSanitizePipe implements PipeTransform {
    public constructor(private readonly domSanitizer: DomSanitizer) {}

    public transform(html: string): SafeHtml {
        // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
}
